<template>
  <div class="animated efficiency">

    <OrderTable
        :title="`${$t('pages.receipt')}`"
        :headColumns="headColumns"
        :footColumns="footColumns"
        :rows="rows"
        :disableActionBTN="true"
        :isActiveBtn="true"
        :key="'order-table-receipt'"
        :isLoading="loading"
        @downloadPdfReceipt="downloadPdfReceipt"
        @uploadImageReceipt="uploadImageReceipt"
        @downloadAllReceipt="downloadAllReceipt"
        @changeVal="changeValReciept"
    ></OrderTable>
    <!--<StatisticTable :headColumns="headColumns"-->
                    <!--:footColumns="footColumns"-->
                    <!--:rows="rows"-->
                    <!--ref="statisticTable"-->
                    <!--:title="`${$t('pages.order')}`">-->
    <!--</StatisticTable>-->
  </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import Storage from '../../../api/Storage'
  import OrderTable from '../../../components/OrderTable'
  import { map, forEach, isEqual, isEmpty } from 'lodash'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'

  export default {
    name: 'Receipt',
    components: {
      Filters,
      OrderTable
    },
    props: {
      rowsReceipt: Array,
      loading: Boolean
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          operatorFilter: true
        },
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.country'), field: 'country_id'},
          {label: this.$root.$t('statistic.product'), field: 'product_id'},
          {label: this.$root.$t('statistic.ordered'), field: 'orders_count'},
          {label: this.$root.$t('statistic.price'), field: 'price', input: {type: 'text'}},
          {label: this.$root.$t('statistic.logistic'), field: 'logistic', input: {type: 'text'}},
          {label: this.$root.$t('statistic.customs'), field: 'customs', input: {type: 'text'}},
          {label: this.$root.$t('statistic.price_for_one'), field: 'price_for_one'},
          {label: this.$root.$t('statistic.provider'), field: 'provider'},
          {label: this.$root.$t('statistic.times'), field: 'delivery_time'},
          {label: this.$root.$t('statistic.credit'), field: 'credit', input: {type: 'text'}, color: [{value: 0, bg: '#53d3a2'}, {value: 'else', bg: '#ef9a9a'}]},
          {label: this.$root.$t('statistic.comment'), field: 'comment', input: {type: 'text'}},
          {label: this.$root.$t('statistic.expiration_date'), field: 'expiration_date'}
        ],
        rows: [],
        footColumns: {}
      }
    },
    watch: {
      rowsReceipt: function (newq, old) {
        if (!isEqual(newq, old)) {
          this.calculateRows(newq)
        }
      }
    },
    mounted () {
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows(this.rowsReceipt)
      })
    },
    methods: {
      calculateRows: function (rowsReceipt) {
        this.rows = []
        map(rowsReceipt, (item, index) => {
          const value = []
          let sumByOne = null
          if (!item.customs && !item.logistic) {
            sumByOne = Number(item.price)
          } else if (!item.logistic) {
            sumByOne = Number(item.price) + Number(item.customs)
          } else if (item.customs && item.logistic && item.price) {
            sumByOne = Number(item.price) + Number(item.customs) + Number(item.logistic)
          } else if (!item.customs) {
            sumByOne = Number(item.price) + Number(item.logistic)
          }
          let creditSum = Number((sumByOne * item.orders_count).toFixed(2))
          let auxvalue
          forEach(this.headColumns, (headCol) => {
            if (headCol.field === 'price' || headCol.field === 'price_for_one') {
              if (Storage.selectedCountry.id === -1) {
                if (item.country_id === 77 || item.country_id === 1535 || item.country_id === 1547) {
                  auxvalue = '₽'
                } else {
                  auxvalue = '$'
                }
              } else {
                if (Storage.selectedCountry.currency === 'RUB') {
                  auxvalue = Storage.selectedCountry.currency_symbol
                } else {
                  auxvalue = '$'
                }
              }
            } else if (headCol.field === 'orders_count') {
              auxvalue = isEmpty(auxvalue) ? 'шт.' : ''
            } else {
              auxvalue = null
            }
            if (headCol.field === 'price') {
              value.push({
                key: headCol.field,
                input: headCol.input ? headCol.input : null,
                value: Number(item.price),
                color: headCol.color ? headCol.color : null,
                aux: auxvalue
              })
            } else if (headCol.field === 'price_for_one') {
              value.push({
                key: headCol.field,
                input: headCol.input ? headCol.input : null,
                value: sumByOne.toFixed(2),
                color: headCol.color ? headCol.color : null,
                aux: auxvalue
              })
            } else if (headCol.field === 'credit') {
              value.push({
                key: headCol.field,
                input: headCol.input ? headCol.input : null,
                value: creditSum,
                color: headCol.color ? headCol.color : null,
                aux: auxvalue
              })
            } else {
              value.push({
                key: headCol.field,
                input: headCol.input ? headCol.input : null,
                value: item[headCol.field],
                color: headCol.color ? headCol.color : null,
                aux: auxvalue
              })
            }
          })
          this.rows.push({
            key: item.id,
            value
          })
        })
        this.footColumns = {}
      },
      downloadPdfReceipt (id) {
        this.$emit('downloadPdfReceipt', id)
      },
      downloadAllReceipt (row) {
        this.$emit('downloadAllReceipt', row.rows)
      },
      uploadImageReceipt (id, files, name) {
        this.$emit('uploadImageReceipt', id, files, name)
      },
      changeValReciept (key, cell) {
        this.$emit('changeVal', { id: key, title: cell.key, value: cell.value })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Receipt.vue?f415a042